module.exports = __webpack_public_path__ + "img/menu3.1351d0a8.png";